import { FilterDefinition } from 'src/uniform/contenttypes/filterDefinition';

import { applyFilters } from '../../../filterable-gallery/src/utils/filterEngine';

import type { UniformFilterObject } from '../../../filterable-gallery/src/utils/types';
import type { CareersDataItem, FacetOptionCounts } from '../types';

/**
 * Per-facet recompute (plan §5.3): for facet F, narrow items by every OTHER
 * committed facet first (excluding F's own selections entirely, not just
 * clearing them), then tally each of F's options against that narrowed set —
 * so an option's count never reads 0 merely because a sibling option in the
 * same facet is checked. Both passes reuse `applyFilters` so the
 * equals/includes/contains + pipe-joined-id match semantics stay
 * single-sourced instead of being reimplemented here.
 */
export function countFacetOptions(
	items: CareersDataItem[],
	filterDefs: FilterDefinition[],
	filterObject: UniformFilterObject,
): FacetOptionCounts {
	const result: FacetOptionCounts = {};

	for (const filter of filterDefs) {
		const otherFilters = filterDefs.filter((def) => def.id !== filter.id);
		const itemsNarrowedByOtherFacets = applyFilters(items, otherFilters, filterObject);

		const optionValues = Object.keys(filterObject[filter.id] ?? {});
		const counts: Record<string, number> = {};

		for (const optionValue of optionValues) {
			const onlyThisOptionSelected: UniformFilterObject = {
				[filter.id]: {
					[optionValue]: { committedActive: true, stagedActive: true },
				},
			};
			counts[optionValue] = applyFilters(
				itemsNarrowedByOtherFacets,
				[filter],
				onlyThisOptionSelected,
			).length;
		}

		result[filter.id] = counts;
	}

	return result;
}
